var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carousel-wrapper" }, [
    _c(
      "div",
      { staticClass: "carousel" },
      _vm._l(_vm.visibleImages, function(image, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "bg-gray carousel-item-v2",
            class: { center: index === 1 }
          },
          [
            image
              ? _c("img", {
                  key: _vm.currentIndex + "-" + index,
                  attrs: {
                    src: "/static/img/acCleaning/" + image,
                    alt: "carousel image"
                  },
                  on: { mouseenter: _vm.stopAutoPlay, mouseleave: _vm.AutoPlay }
                })
              : _vm._e()
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.images.length > 0
      ? _c(
          "div",
          { staticClass: "controll-dot mt-5" },
          [
            _vm._l(_vm.images.length, function(dot, indexDot) {
              return _c("span", {
                key: indexDot,
                class: { "active-dot": _vm.currentIndex === indexDot },
                on: {
                  click: function($event) {
                    _vm.currentIndex = indexDot
                  }
                }
              })
            }),
            _vm._v(" "),
            _c("i", {
              staticClass: "player-control rounded-full p-2",
              class: [
                _vm.autoPlayStatus ? "fas fa-pause" : "fas fa-play",
                {
                  "active-player": _vm.autoPlayStatus
                }
              ],
              on: { click: _vm.toggleAutoPlay }
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    false
      ? _c("div", { staticClass: "d-flex flex-column gap-2 border-1" }, [
          _vm._v("\n    display status working : for Dev\n    "),
          _c("span", [
            _vm._v("autoPlayStatus : " + _vm._s(_vm.autoPlayStatus))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "material-icons" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.autoPlayStatus ? "pause" : "play_arrow") +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("currentIndex : " + _vm._s(_vm.currentIndex))]),
          _vm._v(" "),
          _c("span", [_vm._v("images.length : " + _vm._s(_vm.images.length))])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bce16da", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bce16da","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/materials/Carousel.vue
// module id = 1572
// module chunks = 0